<script>
  export let width = '100%'
  export let height = '20px'
  export let styleCustom = ''
</script>

<div
  class="skeleton-element"
  style="width: {width}; height: {height}; {styleCustom}"
></div>

<style>
  .skeleton-element {
    background-color: #e0e0e0;
    border-radius: 4px;
    animation: shimmer 1.5s infinite linear;
    background-image: linear-gradient(90deg, #e0e0e0, #f0f0f0, #e0e0e0);
    background-size: 400% 100%;
    background-repeat: no-repeat;
  }
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
</style>
